import React, {useCallback, useState} from 'react';
import Breadcrumb from '../../common/breadcrumb';
import LoadingIndicator from "../../common/loadingIndicator";
import MessageEmptyData from '../../common/messageEmptyData';
import BusinessDevelopmentPieChart from './charts/businessDevelopmentPieChart';
import BusinessDevelopmentBarChart from './charts/businessDevelopmentBarChart';
import ChartContainer from './chartContainer';
import jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas'; 
import BusinessDevelopmentDashboardFilters from './businessDevelopmentDashboardFilters';

/**
 * Business development dashboard component
 * @returns {JSX.Element}
 * @constructor
 */

const BusinessDevelopmentDashboard = () => {
    const [data, setData] = useState([]);
    const [reportFilters, setReportFilters] = useState({
        dateFrom: '',
        dateTo: '',
        isLoading: false,
        isSubmitted: false,
    });

    const handleExportClick = useCallback(() => {
        const chartContainer = document.body.querySelector('#charts');
        const doc = new jsPDF({ orientation:  'portrait', unit: 'px', format: [chartContainer.clientHeight, chartContainer.clientWidth] });
        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();
        html2canvas(document.body.querySelector('#charts'), { scale: 2 }).then(function(canvas) {
            const image = canvas.toDataURL('image/png', 1.0);
            doc.addImage(image, 'PNG', 0, 0, width, height)
            doc.save(`businessDevelopmentCharts-${reportFilters.dateFrom}_${reportFilters.dateTo}.pdf`);
        });

    }, [reportFilters])

    return (
        <div className="container-fluid">
            <Breadcrumb title="Dashboard" parent="Business Development"/>
            <BusinessDevelopmentDashboardFilters 
                setData={setData} 
                setReportFilters={setReportFilters} 
                onExportClick={handleExportClick} 
            />
                {
                    !Object.keys(data).map(key => data[key]).every(chartData => chartData.data.length === 0) ? (
                        <div id='charts' className="row">
                            {data.number_by_report_types.data.length > 0 && <ChartContainer>
                                <BusinessDevelopmentPieChart
                                    data={data.number_by_report_types.data}
                                    title="# Of Opportunities By Report Type"
                                />
                            </ChartContainer>}
                            {data.number_by_equipment_types.data.length > 0 && <ChartContainer>
                                <BusinessDevelopmentBarChart
                                    data={data.number_by_equipment_types.data}
                                    title="# Of Pipeline Opportunities By Equipment Type"
                                />
                            </ChartContainer>}
                            {data.value_by_equipment_types.data.length > 0 && <ChartContainer>
                                <BusinessDevelopmentPieChart
                                    data={data.value_by_equipment_types.data}
                                    title="Value ($) Of Pipeline Opportunities By Equipment Type"
                                />
                            </ChartContainer>}
                            {data.value_by_discipline.data.length > 0 && <ChartContainer>
                                <BusinessDevelopmentPieChart
                                    data={data.value_by_discipline.data}
                                    title="Value ($) Of Pipeline Opportunities By Discipline"
                                />
                            </ChartContainer>}
                            {data.percents_by_discipline.data.length > 0 && <ChartContainer>
                                <BusinessDevelopmentPieChart
                                    data={data.percents_by_discipline.data}
                                    title="% Of Pipeline Opportunities By Discipline"
                                />
                            </ChartContainer>}
                            {data.percents_by_states.data.length > 0 && <ChartContainer>
                                <BusinessDevelopmentPieChart
                                    data={data.percents_by_states.data}
                                    title="% Of Pipeline Opportunities By State"
                                />
                            </ChartContainer>}
                            {data.value_by_state.data.length > 0 &&<ChartContainer>
                                <BusinessDevelopmentPieChart
                                    data={data.value_by_state.data}
                                    title="Value ($) Of Pipeline Opportunities By State"
                                />
                            </ChartContainer>}
                            {data.value_by_periods.data.length > 0 &&<ChartContainer>
                                <BusinessDevelopmentBarChart
                                    data={data.value_by_periods.data}
                                    title="Value ($) Of Pipeline Opportunities By Period"
                                />
                            </ChartContainer>}
                            {data.number_by_periods.data.length > 0 &&<ChartContainer>
                                <BusinessDevelopmentBarChart
                                    data={data.number_by_periods.data}
                                    title="# Of Pipeline/Awarded Opportunities By Period"
                                />
                            </ChartContainer>}
                        </div>
                    ) : <MessageEmptyData />
                }
            <LoadingIndicator isLoading={reportFilters.isLoading}/>
        </div>
    );
};

export default BusinessDevelopmentDashboard;
